import { HttpServiceResponse } from '../../shared'
import { ApplicationAddAction } from '../models/application.types'
import { ApplicationAddProviderParams } from '../models/application/application-add.params.model'
import AbstractApplicationProvider from './application-abstract.provider'

export class ApplicationAddProvider extends AbstractApplicationProvider {
  urlPath = 'application_add_api'

  public changeEssence<T>(
    action: ApplicationAddAction,
    params: ApplicationAddProviderParams,
  ): Promise<HttpServiceResponse<T>> {
    //@ts-ignore
    const { AppID, HashSum_AppID_, ClientID, HashSum_ClientID_, ...rest } = params
    const query = this.query.stringify({
      action,
      AppID,
      HashSum_AppID_,
      ClientID,
      HashSum_ClientID_,
    })

    return this.http.post(`${this.url}?${query}`, { ...rest })
  }
}
